import types from '../types';
import baseUrl from '../baseUrl';

const GetRBSPricing = (clientId) => ({
    type: types.GET_RBS_PRICING,
    payload: {},
    meta: {
        type: 'apijson',
        url: `${baseUrl}/RBSPrices/${clientId}`,
    },
    options: {
        method: 'GET'
    }
})

export default GetRBSPricing;
